import { useEffect, useState } from "react";
import CadBasePage from "../../../components/CadBasePage/insert";
import api from "../../../config";
import { useParams, useHistory } from "react-router-dom";
import Inputs from "./Inputs";
import { changeDisable, objectToURLParams, showMessageError } from "../../../classes/functions";
import Buttons from "./Buttons";
import { toast } from "react-toastify";

export default function CadGeneralParameters(){
    const {option, id} = useParams();
    const history = useHistory();
    const [carrying, setCarrying] = useState(false);
    const [view, setView] = useState(false);
    const [infos, setInfos] = useState({
        nome: "",
        descricao: "",
        tipo: 0
    });

    function getParameterByCompany(){
        api
        .get(`/api/parametros/${id}`)
        .then((response) => {
            setInfos(response.data);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        })
        .finally(() => {
            setCarrying(false);

            setView(changeDisable(option));
        });
    }

    function save(event){
        const isEdit = (id !== undefined);
        
        setCarrying(true);
        event.preventDefault();

        api
        [isEdit ? "put" : "post"](`/api/parametros${isEdit ? `/${id}` : ""}`, objectToURLParams(infos))
        .then((response) => {
            setInfos({nome: response.data.nome, descricao: response.data.descricao, tipo: response.data.tipo});

            toast.success(`${isEdit ? "Atualizado" : "Cadastrado"} com sucesso!`);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        })
        .finally(() => {
            setCarrying(false);
        });
    }
    
    function cancel() {
        history.push('/general_parameters');
    }

    useEffect(() => {
        if(id, option){
            getParameterByCompany();
        }
    }, [id, option]);

    return (
        <CadBasePage carrying={carrying} title="Cadastro de Parâmetros Gerais" URLToBack="/general_parameters">
            <Inputs infos={{state: infos, setState: setInfos}} />
            <Buttons view={view} save={save} cancel={cancel} />
        </CadBasePage>
    )
}